<template>
  <div :class="['definition-container', id]">
    <transition name="fade" mode="out-in">
      <div v-if="!loading" id="container_form_definition" :class="['w3-contanier', type.id, type.modeView, open ? 'open' : '', {'template': isTemplate()}]">
        <!-- header for definition name [id] -->
        <div v-if="(type.id === 'search' && fieldsHeader !== '') || ((type.id === 'definition' || type.id === 'template') && (fieldsHeader !== '' || headerLang !== ''))" :class="['definition-title', 'w3-row']">
          <transition name="fade" mode="out-in">
            <span v-if="fieldsHeader !== ''" class="fieldsHeaderTitle" v-text="fieldsHeader" />
            <span v-else-if="headerLang !== ''" class="headerLangTitle" v-text="getLang(headerLang)" />
          </transition>
        </div>

        <!-- for definition type 'definition' -->
        <div
          id="form_definition" class="w3-row" v-bind:class="{'w3-dropdown-content': open,'w3-animate-opacity': open === false && cont > 0}"
        >
          <form v-on:submit.prevent>

            <!-- Carousel presentation -->
            <carousel v-if="isCarousel()"
              v-bind="carouselOptions"
              :validationFunction="carouselValidationFunction"
              :outerNavigation="carouselNavigation"
              @navigation-click="navigationClick"
              @pagination-click="paginationClick"
              @pageChange="pageChange"
              @slideCount="slideCountEv"
            >
              <slide v-for="(child, index) in definitionContent.requestDefinition" :key="child.id">
                <definition-obj :key="child.id"
                  :id="child.id"
                  :definitionId="id"
                  :reqDef="child"
                  :reqObj="getRequestObjectById(child.id)"
                  :content="definitionContent"
                  :modeView="type.modeView"
                  :validateForm="getCarouselValidateForm(index)"
                  :validateAddForm="validateAddForm"
                  :repeatableGroupId="getRepeatableGroupId(child)"
                  :languageSelected="languageSelected"
                  :definitionContentId="definitionContentId"
                  :definitionContentCode="definitionContentCode"
                  :requestObjectForAddModified="requestObjectForAddModified"
                  :language="language"
                  :visualDefinition="visualDefinition"
                  :authorization="authorization"
                  :type="type"
                  :visuals="visuals"
                  :apiparams="apiparams"
                  :formAddErrors="formAddErrors"
                  :formAddSaved="formAddSaved"
                  :formAddRemoved="formAddRemoved"
                  @refreshDefinition="refreshDefinition"
                  @repeatableGroupModified="modifyDefinitionContentRequestObject"
                  @activateValidatingAddForm="activateValidatingAddForm"
                  @deactivateValidatingAddForm="deactivateValidatingAddForm"
                  @errorAddForm="errorAddForm"
                  @errorModifyForm="errorModifyForm"
                  @formAddSaved="addSaved"
                  @newLanguageSelected="newLanguageSelected"
                  @modifyRepeatibleGroup="modifyDefinitionContentRequestObject"
                  @modifyingAddForm="modifyingAddForm"
                  @removingAddForm="removingAddForm"
                  @conditionalDefinitionChange="conditionalDefinitionChange"
                  @refreshDefinitionContent="refreshDefinitionContent"
                  @waitingProcessInit="waitingProcessInit"
                  @taskLink="taskLink"
                />
              </slide>
            </carousel>

            <definition-obj v-else v-for="reqDef in definitionContent.requestDefinition" :key="reqDef.id"
              :id="reqDef.id"
              :definitionId="id"
              :reqDef="reqDef"
              :reqObj="getRequestObjectById(reqDef.id)"
              :content="definitionContent"
              :modeView="type.modeView"
              :validateForm="validateForm"
              :validateAddForm="validateAddForm"
              :repeatableGroupId="getRepeatableGroupId(reqDef)"
              :languageSelected="languageSelected"
              :definitionContentId="definitionContentId"
              :definitionContentCode="definitionContentCode"
              :requestObjectForAddModified="requestObjectForAddModified"
              :language="language"
              :visualDefinition="visualDefinition"
              :authorization="authorization"
              :type="type"
              :visuals="visuals"
              :apiparams="apiparams"
              :formAddErrors="formAddErrors"
              :formAddSaved="formAddSaved"
              :formAddRemoved="formAddRemoved"
              @refreshDefinition="refreshDefinition"
              @repeatableGroupModified="modifyDefinitionContentRequestObject"
              @activateValidatingAddForm="activateValidatingAddForm"
              @deactivateValidatingAddForm="deactivateValidatingAddForm"
              @errorAddForm="errorAddForm"
              @errorModifyForm="errorModifyForm"
              @formAddSaved="addSaved"
              @newLanguageSelected="newLanguageSelected"
              @modifyRepeatibleGroup="modifyDefinitionContentRequestObject"
              @modifyingAddForm="modifyingAddForm"
              @removingAddForm="removingAddForm"
              @conditionalDefinitionChange="conditionalDefinitionChange"
              @refreshDefinitionContent="refreshDefinitionContent"
              @waitingProcessInit="waitingProcessInit"
              @taskLink="taskLink"
            />
          </form>
        </div>

        <!-- for definition type 'template' -->
        <div v-if="isTemplate() && !loading" class="definitionObj">
          <div class="definition-wrapper text">
            <div class="languageSelectorOrTask">
              <definition-multilanguage
                :definition="getTemplateReqDef('contenthtml')"
                :object="getTemplateReqObj('contenthtml')"
                :languageSelected="languageSelected" :translating="translating" :language="language" :apiparams="apiparams"
                @newLanguageSelected="newLanguageSelected" @copy="launchCopyTemplate"
              />
            </div>
          </div>
          <transition name="fade" mode="out-in">
            <grapes-js-editor
              v-if="languageSelected && !savingLanguageTemplate && this.definitionContent.requestDefinition"
              :content="getContentValue()"
              :wsEndpoint="getTemplateValue('wsendpoint')"
              :wsFileuploadProcessor="getTemplateValue('wsfileuploadprocessor')"
              :wsGetProcessor="getTemplateValue('wsgetprocessor')"
              :save="saveTemplate"
              :lang="getLang()"
              :languageSelected="languageSelected"
              :type="getTypeValue()"
              :texts="editorTexts"
              :variables="{
                individual: this.getTemplateDomain('individualformvars'),
                professional: this.getTemplateDomain('professionalformvars'),
                indicator: this.getTemplateDomain('individualindicatorvars')
              }"
              :apiparams="apiparams"
              @editorLoaded="definitionLoaded"
              @editorSave="editorSave"
            />
          </transition>
        </div>

        <!-- for definition type 'workflow' -->
        <modeler v-if="type.id === 'workflow' && !loading"
          :newDiagram="newDiagram"
          :save="saveTemplate"
          @bpmnModelerLoaded="definitionLoaded"
          @diagramSaved="diagramSaved"
        />
      </div>
    </transition>

    <transition name="fade" mode="out-in">
      <!-- save / modify / delete buttons and messages -->
      <action-buttons v-if="!embeddedDefinition && type.actions && !loading"
        :actions="type.actions"
        :definitionContentId="definitionContentId"
        :validating="validateForm.validating"
        :validatingAddForm="validateAddForm.validatingAdd"
        :formErrors="formErrors"
        :formAddErrors="formAddErrors"
        :formModifyErrors="formModifyErrors"
        :formSaved="formSaved"
        :resultSuccessMsg="resultSuccessMsg"
        :formAddSaved="formAddSaved"
        :formSavedError="formSavedError"
        :formDeleted="formDeleted"
        :formConfirmDelete="formConfirmDelete"
        :validatingDelete="validatingDelete"
        :formSavedErrorMsg="formSavedErrorMsg"
        :language="language"
        :authorization="authorization"
        :type="type"
        :visuals="visuals"
        :apiparams="apiparams"
        :hideButtons="hideButtons"
        :menuName="menuName"
        :carouselOptions="carouselOptions"
        :carouselPage="carouselPage"
        :slideCount="slideCount"
        :requestDefinition="definitionContent.requestDefinition"
        @callDelete="callDelete"
        @callCreate="callCreate"
        @callUpdate="callUpdate"
        @popupClose="popupClose"
        @confirmDelete="confirmDelete"
        @cancelDelete="cancelDelete"
        @callPrevCarouselPage="callPrevCarouselPage"
        @callNextCarouselPage="callNextCarouselPage"
        @callPaginationCarouselPage="callPaginationCarouselPage"
      />
    </transition>

  </div>
</template>

<script>
import Modeler from 'vue-bpmn-js-modeler' // comment for 'definition.js' low size
import GrapesJsEditor from 'vue-grapesjs-editor' // comment for 'definition.js' low size
import VueTransferDom from 'vue-definition-utils/src/utils/transferDom' // comment for 'definition.js' low size
import VTooltip from 'v-tooltip' // comment for 'definition.js' low size
import DefinitionMultilanguage from './item/multilanguage' // comment for 'definition.js' low size
import DefinitionTask from './item/task' // comment for 'definition.js' low size
import Vue from 'vue'
import DefinitionObj from './item/definitionObj'
import ActionButtons from './action'
import transport from 'vue-definition-utils/src/utils/transport'
import PrettyCheck from 'pretty-checkbox-vue/check'
import PrettyRadio from 'pretty-checkbox-vue/radio'
import { Carousel, Slide } from 'vue-carousel-tmd'
import * as api from './utils/api'
import moment from 'moment'
import language from './language'
import Visual from 'vue-definition-utils/src/utils/visual'

Vue.use(VTooltip) // comment for 'definition.js' low size
Vue.use(VueTransferDom /*, {name: 'transferDom'} */) // comment for 'definition.js' low size
/*
  template: '<div v-transfer-dom>foo</div>', // div will be appended to body(default)
  template: '<div v-transfer-dom.prepend>foo</div>', // div will be prepended to body(default)
  template: '<div v-transfer-dom:bar>foo</div>', // div will be appended to #bar(document.getElementById)
  template: '<div v-transfer-dom:bar.prepend>foo</div>', // div will be prepended to #bar(document.getElementById)
*/
Vue.component('p-check', PrettyCheck)
Vue.component('p-radio', PrettyRadio)

export default {
  name: 'definition',
  props: {
    type: {
      type: Object
    },
    content: {
      type: Object
    },
    id: {
      type: String
    },
    language: {
      type: Object
    },
    visuals: {
      type: Array
    },
    authorization: {
      type: String
    },
    apiparams: {
      type: Object
    },
    fromPopup: {
      type: Boolean
    },
    saveDefinition: {},
    saveDefinitionTo: {},
    embeddedDefinition: {},
    builderModifyCall: {},
    builderDeleteCall: {},
    showloading: {
      type: Boolean,
      default: false
    },
    onloadfunction: {
      type: String
    },
    loadedstyleclasses: {
      type: String
    },
    sdcontainer: {
      type: String
    },
    menuName: {
      type: String
    },
    taskObject: {
      type: Array
    }
  },
  data () {
    return {
      fieldsHeader: '',
      headerLang: '',
      open: false,
      cont: 0,
      loading: false,
      translating: false,
      definitionContent: {},
      definitionContentId: null,
      definitionContentCode: null,
      validateForm: {
        validating: false,
        timeEvent: null
      },
      validateAddForm: {
        repeatableGroupId: null,
        validatingAdd: false,
        timeEventAdd: null
      },
      formErrors: 0,
      formAddErrors: 0,
      formModifyErrors: 0,
      formSaved: false,
      resultSuccessMsg: null,
      formAddSaved: false,
      formSavedError: false,
      formSavedErrorMsg: null,
      formDeleted: false,
      formConfirmDelete: false,
      validatingDelete: false,
      confirmDeleteTimerId: null,
      languageSelected: null,
      previousLanguageKey: null,
      saveTemplate: null,
      savingLanguageTemplate: false,
      copyingTemplateLanguage: null,
      requestObjectForAddModified: {
        ts: null
      },
      newDiagram: '<?xml version="1.0" encoding="UTF-8"?><bpmn2:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn2="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xsi:schemaLocation="http://www.omg.org/spec/BPMN/20100524/MODEL BPMN20.xsd" id="sample-diagram" targetNamespace="http://bpmn.io/schema/bpmn"><bpmn2:process id="Process_1" isExecutable="false"><bpmn2:startEvent id="StartEvent_1"/></bpmn2:process><bpmndi:BPMNDiagram id="BPMNDiagram_1"><bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1"><bpmndi:BPMNShape id="_BPMNShape_StartEvent_2" bpmnElement="StartEvent_1"><dc:Bounds height="36.0" width="36.0" x="412.0" y="240.0"/></bpmndi:BPMNShape></bpmndi:BPMNPlane></bpmndi:BPMNDiagram></bpmn2:definitions>',
      visualDefinition: null,
      formAddRemoved: {
        code: null,
        id: null,
        removed: false,
        ts: null
      },
      hideButtons: null,
      editorTexts: {
        addIndividualParamsTitle: this.getLang('addIndividualParamsTitle'),
        addProfessionalParamsTitle: this.getLang('addProfessionalParamsTitle'),
        addIndicatorParamsTitle: this.getLang('addIndicatorParamsTitle'),
        selectText: this.getLang('select')
      },
      carouselOptions: null,
      carouselPage: null,
      carouselValidateForm: [],
      slideCount: null,
      carouselNavigation: null
    }
  },
  components: {
    GrapesJsEditor, // comment for 'definition.js' low size
    Modeler, // comment for 'definition.js' low size
    DefinitionMultilanguage, // comment for 'definition.js' low size
    DefinitionTask, // comment for 'definition.js' low size
    DefinitionObj,
    ActionButtons,
    Carousel,
    Slide
  },
  beforeMount () {
    this.getDefinitionContent()
  },
  methods: {
    taskLink (obj) {
      this.$emit('taskLink', obj)
    },
    refreshDefinition (newReqObj, scope) {
      if (newReqObj && scope === 'full') {
        this.definitionContent.requestObject = newReqObj
      } else if (newReqObj) {
        for (var i = 0; i < this.definitionContent.requestObject.length; i++) {
          this.definitionContent.requestObject[i] = transport.methods.changeRequestObject(newReqObj.id, this.definitionContent.requestObject[i], newReqObj)
        }
      }
      this.$emit('refreshDefinition', this.definitionContent.requestObject)

      // header defined by definition
      var languageSelectedKey = null
      if (this.languageSelected) {
        languageSelectedKey = this.languageSelected.key
      }
      this.fieldsHeader = this.visualDefinition.getDefinitionFieldsHeader(this.id, this.definitionContent.requestDefinition, this.definitionContent.requestObject, languageSelectedKey)
    },
    isSaveDefinition () {
      var result = false
      if (this.definitionContent.requestDefinition) {
        result = this.type.id === 'definition' || (this.type.id === 'template' && !this.getTemplateValue('templateurl'))
      }
      return result
    },
    isTemplate () {
      var result = false
      if (this.definitionContent.requestDefinition) {
        result = this.type.id === 'template' && this.getTemplateValue('templateurl')
      }
      return result
    },
    callCreate (stayAfterSave, goToAfterSave) {
      if (this.isSaveDefinition()) {
        this.checkForm(stayAfterSave, 'create', goToAfterSave)
      } else if (this.type.id === 'template' || this.type.id === 'workflow') {
        this.previousLanguageKey = this.languageSelected.key
        this.saveTemplate = {
          ts: moment().valueOf(),
          mode: 'create',
          stayAfter: stayAfterSave,
          goToAfterSave: goToAfterSave
        }
      }
    },
    callUpdate (stayAfterUpdate, goToAfterSave) {
      if (this.isSaveDefinition()) {
        this.checkForm(stayAfterUpdate, 'update', goToAfterSave)
      } else if (this.type.id === 'template' || this.type.id === 'workflow') {
        this.previousLanguageKey = this.languageSelected.key
        this.saveTemplate = {
          ts: moment().valueOf(),
          mode: 'update',
          stayAfter: stayAfterUpdate,
          goToAfterSave: goToAfterSave
        }
      }
    },
    callDelete (confirmDelete) {
      if (!this.validateForm.validating) {
        this.resetMsgAndErrors()

        if (confirmDelete) {
          var self = this
          setTimeout(function () {
            self.formConfirmDelete = true
          }, 300)
          this.startConfirmDeleteTimer()
        } else {
          this.deleteToAPI()
        }
      }
    },
    confirmDelete () {
      if (!this.validatingDelete) {
        this.$emit('callAction', 'delete')
        this.validatingDelete = true
        this.deleteToAPI()
      }
    },
    cancelDelete () {
      if (!this.validatingDelete) {
        var self = this
        setTimeout(function () {
          self.deactivateConfirmDelete()
        }, 200)
      }
      this.validatingDelete = false
    },
    getRequestObjectById (id) {
      return transport.methods.getRequestObjectById(id, this.definitionContent.requestObject)
    },
    getDefinitionContent (forceCall) {
      this.loading = true

      // new Visuals
      this.visualDefinition = new Visual(this.visuals, this.id)
      if (this.visualDefinition && this.visualDefinition.definition) {
        this.hideButtons = this.visualDefinition.definition.hideButtons
      }

      // check if requestDefinition is null
      if ((!this.content.requestDefinition || forceCall) && this.type.endpoint) {
        // remove url query param
        this.$emit('removeUrlQueryParam')

        this.$emit('definitionloading')

        // load new definition
        var dataObj = { }
        if (forceCall) {
          dataObj.id = this.definitionContentId
        }
        api.call({domainEndpoint: this.type.domainEndpoint, url: this.type.endpoint, token: this.type.token, version: this.type.version, method: 'POST', lang: this.getLang(), authorization: this.authorization, data: dataObj})
          .then(resp => {
            // all OK
            if (resp.requestResult) {
              this.setDefinitionContent(resp)
            // KO
            } else {
              this.$emit('definitionerror', {response: {status: 500}}, resp.requestResultError, this.$el)
              this.$emit('formDataActionCalled', false)
            }
          })
          .catch(err => {
            this.$emit('definitionerror', err, {requestErrorType: 'SYSTEM', requestErrorMsg: this.language.error500header}, this.$el)
          })
      // else we get the content past by parent
      } else {
        this.setDefinitionContent(this.content)
      }
    },
    isCarousel () {
      return this.visualDefinition.definition && this.visualDefinition.definition.carouselOptions !== undefined && this.visualDefinition.definition.carouselOptions !== null
    },
    carouselValidationFunction () {
      var slidesPerPage = this.carouselOptions.perPage
      if (!slidesPerPage) {
        slidesPerPage = 2
      }

      var initialChildIndex = (this.carouselPage * slidesPerPage) + slidesPerPage - 1
      var endChildIndex = initialChildIndex + slidesPerPage - 1

      var validationReqDefs = []
      var validationReqObjs = []
      var i = initialChildIndex
      for (i; i <= endChildIndex; i++) {
        validationReqDefs.push(this.definitionContent.requestDefinition[i])
        validationReqObjs.push(this.getRequestObjectById(this.definitionContent.requestDefinition[i].id))
      }

      // carousel validation refresh
      var newCarouselValidateForm = []
      for (var j = 0; j < this.definitionContent.requestDefinition.length; j++) {
        if (j >= initialChildIndex && j <= endChildIndex) {
          newCarouselValidateForm.push({
            validating: true,
            timeEvent: moment().valueOf()
          })
        } else {
          newCarouselValidateForm.push({
            validating: false,
            timeEvent: moment().valueOf()
          })
        }
      }
      this.carouselValidateForm = newCarouselValidateForm

      var errors = transport.methods.validateForm(this.type.modeView, validationReqDefs, validationReqObjs)
      var formErrors = errors.errorsNumber

      this.$nextTick(() => {
        if (formErrors > 0) {
          for (var j = 0; j < this.carouselValidateForm.length; j++) {
            if (j >= initialChildIndex && j <= endChildIndex) {
              this.carouselValidateForm[j].validating = false
              this.carouselValidateForm[j].timeEvent = null
            }
          }
        }
      })

      return (formErrors === 0)
    },
    getCarouselValidateForm (index) {
      return this.carouselValidateForm[index]
    },
    navigationClick (direction, validation) {
      this.getCarouselAction('navigation', direction, validation)
    },
    paginationClick (page, validation) {
      this.getCarouselAction('pagination', page, validation)
    },
    pageChange (page) {
      this.getCarouselAction('pageChange', page)
    },
    getCarouselAction (action, actionData, validation) {
      var result = {
        id: this.id,
        action: action,
        fromPage: this.carouselPage,
        actionData: {}
      }

      if (actionData !== undefined && actionData !== null) {
        if (action === 'navigation') {
          result.actionData.direction = actionData
        } else if (action === 'pagination' || action === 'pageChange') {
          result.actionData.page = actionData
          if (action === 'pageChange') {
            this.carouselPage = actionData
          }
        }

        if (action !== 'pageChange') {
          result.actionData.validation = validation
        }
      }

      this.$emit('definitioncarouselaction', result)

      return result
    },
    callPrevCarouselPage () {
      this.carouselNavigation = 'backward'
      this.$nextTick(() => {
        this.carouselNavigation = null
      })
    },
    callNextCarouselPage () {
      this.carouselNavigation = 'forward'
      this.$nextTick(() => {
        this.carouselNavigation = null
      })
    },
    callPaginationCarouselPage (page) {
      this.carouselOptions.navigateTo = -1
      this.$nextTick(() => {
        this.carouselOptions.navigateTo = page
      })
    },
    slideCountEv (slideCount) {
      this.slideCount = slideCount
    },
    setContentId () {
      // get definition type id value
      var requestObjectId = transport.methods.getRequestObjectById(
        transport.methods.getAliasTypeId(this.definitionContent.requestDefinition),
        this.definitionContent.requestObject
      )
      if (requestObjectId) {
        this.definitionContentId = requestObjectId.textValue
      }
    },
    setContentCode () {
      // get definition type code value
      var requestObjectCode = transport.methods.getRequestObjectById(
        transport.methods.getAliasTypeCode(this.definitionContent.requestDefinition, false),
        this.definitionContent.requestObject
      )
      if (requestObjectCode) {
        this.definitionContentCode = requestObjectCode.textValue
      }
    },
    setDefinitionContent (content) {
      this.definitionContent = content
      if (this.definitionContent.requestObject === null && this.definitionContent.requestDefinition) {
        this.definitionContent.requestObject = transport.methods.getEmptyRequestObject(this.definitionContent.requestDefinition)
      }

      this.setContentId()
      this.setContentCode()

      // definition loaded (wait if is setted 'template' (with 'templateurl') or 'workflow')
      this.loading = false
      // Defer the callback to be executed after the next DOM update cycle.
      // Use it immediately after you’ve changed some data to wait for the DOM update.
      this.$nextTick(() => {
        if (
          this.type.id === 'definition' ||
          this.type.id === 'search' ||
          (this.type.id === 'template' && !this.getTemplateValue('templateurl'))
        ) {
          this.definitionLoaded()
        }
      })

      // header defined by definition
      var languageKey = null
      if (this.languageSelected) {
        languageKey = this.languageSelected.key
      }
      this.fieldsHeader = this.visualDefinition.getDefinitionFieldsHeader(this.id, this.definitionContent.requestDefinition, this.definitionContent.requestObject, languageKey)
      // header defined statically
      this.headerLang = this.visualDefinition.getDefinitionHeaderLang()

      // Carousel options
      if (this.isCarousel()) {
        this.carouselOptions = this.visualDefinition.definition.carouselOptions
        this.carouselPage = this.carouselOptions.navigateTo
        if (!this.carouselPage) {
          this.carouselPage = 0
        }
        for (var i = 0; i < this.definitionContent.requestDefinition.children.length; i++) {
          this.carouselValidateForm.push({
            validating: false,
            timeEvent: null
          })
        }
      }
    },
    checkForm (stay, action, goTo, code) {
      if (!this.validateForm.validating) {
        this.resetMsgAndErrors()
        // change validateForm / watcher waiting...
        this.activateValidatingForm()
        var self = this
        setTimeout(function () {
          var errors = transport.methods.validateForm(self.type.modeView, self.definitionContent.requestDefinition, self.definitionContent.requestObject)
          self.formErrors = errors.errorsNumber
          if (self.formErrors === 0) {
            // No errors on fields. Let's save/update form data.
            if (action === 'create') {
              self.$emit('callAction', 'create')
              self.createToAPI(stay, goTo)
            } else if (action === 'update') {
              self.$emit('callAction', 'create')
              self.updateToAPI(stay, goTo, code)
            } else if (action === 'none') {
              self.deactivateValidatingForm()
            }

          // Errors on fields.
          } else {
            setTimeout(function () {
              self.deactivateValidatingForm()
              self.$emit('validatingFormError')
            }, 100)
          }
        }, 200)
      }
    },
    resetMsgAndErrors () {
      setTimeout(() => {
        this.formErrors = 0
        this.formAddErrors = 0
        this.formModifyErrors = 0
        this.formSaved = false
        this.resultSuccessMsg = null
        this.formAddSaved = false
        this.formSavedError = false
        this.formSavedErrorMsg = null
      }, 3000)
    },
    apiError (response, status, requestResultError) {
      this.validateForm = {
        validating: false,
        timeEvent: moment().valueOf()
      }
      this.formSavedError = true
      if (response) {
        if (response.requestResultError) {
          if (response.requestResultError.requestErrorMsg) {
            this.formSavedErrorMsg = response.requestResultError.requestErrorMsg
          } else if (response.requestResultError.requestCause) {
            this.formSavedErrorMsg = response.requestResultError.requestCause
          }
        }
      } else {
        this.formSavedErrorMsg = this.getLang('error500header')
      }
      this.$emit('validatingFormError')
      this.$emit('definitionerror', status, requestResultError, this.$el)
    },
    activateValidatingForm () {
      this.validateForm = {
        validating: true,
        timeEvent: moment().valueOf()
      }
    },
    deactivateValidatingForm () {
      this.validateForm = {
        validating: false,
        timeEvent: moment().valueOf()
      }
    },
    activateValidatingAddForm (id, code) {
      this.resetMsgAndErrors()
      this.validateAddForm = {
        repeatableGroupId: id,
        validatingAdd: true,
        timeEventAdd: moment().valueOf()
      }
      this.$emit('modifyingAddForm')
    },
    deactivateValidatingAddForm () {
      this.validateAddForm = {
        repeatableGroupId: null,
        validatingAdd: false,
        timeEventAdd: moment().valueOf()
      }
    },
    deactivateConfirmDelete () {
      this.resetMsgAndErrors()
      this.deactivateValidatingForm()
      this.formConfirmDelete = false
    },
    startConfirmDeleteTimer () {
      if (this.confirmDeleteTimerId) {
        clearTimeout(this.confirmDeleteTimerId)
      }
      var self = this
      this.confirmDeleteTimerId = setTimeout(function () {
        if (self.formConfirmDelete && !self.validatingDelete) {
          self.deactivateConfirmDelete()
        }
      }, 10000)
    },
    createToAPI (stay, goTo) {
      api.call({domainEndpoint: this.type.domainEndpoint, url: this.type.actions.create.endpoint, token: this.type.token, version: this.type.version, method: 'POST', lang: this.getLang(), authorization: this.authorization, data: { requestObject: this.definitionContent.requestObject }})
        .then(resp => {
          if (resp.requestResult) {
            this.formSaved = true
            this.resultSuccessMsg = resp.requestResultSuccess
            if (stay) {
              this.$emit('definitionsaved', this.definitionContent.requestObject, resp)
              this.$emit('formDataActionCalled', stay)

              // save and continue edit
              if (this.type.actions.create.callback && this.type.actions.create.callback.success) {
                if (this.type.actions.create.callback.success !== this.id) {
                  this.$emit('changeUrl', {name: this.type.actions.create.callback.success, params: { id: resp.requestObjectId }})
                } else {
                  this.getDefinitionContent(true)
                }
              // save and new one
              } else {
                this.definitionContent.requestObject = transport.methods.getEmptyRequestObject(this.definitionContent.requestDefinition)
                this.resetMsgAndErrors()
                this.deactivateValidatingForm()
              }
            } else {
              this.$emit('definitionsaved', this.definitionContent.requestObject, resp)
              this.$emit('formDataActionCalled', stay)
              if (goTo) {
                this.$emit('changeUrl', goTo)
              } else {
                this.$emit('closeDetail')
              }
            }
          } else {
            this.apiError(resp, {response: {status: 500}}, resp.requestResultError)
            if (this.type.actions.create.callback && this.type.actions.create.callback.error) {
              if (this.type.actions.create.callback.error !== this.id) {
                this.$emit('changeUrl', {name: this.type.actions.create.callback.error})
              } else {
                this.getDefinitionContent(true)
              }
            }
          }
        })
        .catch(err => {
          this.resetMsgAndErrors()
          this.deactivateValidatingForm()
          this.apiError(null, err, {requestErrorType: 'SYSTEM', requestErrorMsg: this.language.error500header})
        })
    },
    updateToAPI (stay, goTo, code) {
      if (this.definitionContentId) {
        var apiCode = this.definitionContentCode
        if (code !== undefined) {
          apiCode = code
        }

        api.call({domainEndpoint: this.type.domainEndpoint, url: this.type.actions.update.endpoint, token: this.type.token, version: this.type.version, method: 'POST', lang: this.getLang(), authorization: this.authorization, data: { id: this.definitionContentId, code: apiCode, requestObject: this.definitionContent.requestObject }})
          .then(resp => {
            if (resp.requestResult) {
              this.formSaved = true
              this.resultSuccessMsg = resp.requestResultSuccess

              if (stay) {
                this.$emit('definitionupdated', this.definitionContent.requestObject, resp)
                this.$emit('formDataActionCalled', stay)
                this.resetMsgAndErrors()
                this.deactivateValidatingForm()

                if (goTo && goTo === 'refresh') {
                  // 'true' to force definition call
                  this.getDefinitionContent(true)
                } else if (this.type.actions.update.callback && this.type.actions.update.callback.success) {
                  if (this.type.actions.update.callback.success !== this.id) {
                    this.$emit('changeUrl', {name: this.type.actions.update.callback.success, params: { id: this.definitionContentId }})
                  } else {
                    this.getDefinitionContent(true)
                  }
                }
              } else {
                this.$emit('definitionupdated', this.definitionContent.requestObject, resp)
                this.$emit('formDataActionCalled', stay)
                if (goTo) {
                  this.$emit('changeUrl', goTo)
                } else if (this.type.actions.update.callback && this.type.actions.update.callback.success) {
                  if (this.type.actions.update.callback.success !== this.id) {
                    this.$emit('changeUrl', {name: this.type.actions.update.callback.success, params: { id: resp.requestObjectId }})
                  } else {
                    this.getDefinitionContent()
                  }
                } else {
                  this.$emit('closeDetail')
                }
              }
            } else {
              this.apiError(resp, {response: {status: 500}}, resp.requestResultError)
              if (this.type.actions.update.callback && this.type.actions.update.callback.error) {
                if (this.type.actions.update.callback.error !== this.id) {
                  this.$emit('changeUrl', {name: this.type.actions.update.callback.error, params: { id: resp.requestObjectId }})
                } else {
                  this.getDefinitionContent(true)
                }
              }
            }
          })
          .catch(err => {
            this.resetMsgAndErrors()
            this.deactivateValidatingForm()
            this.apiError(null, err, {requestErrorType: 'SYSTEM', requestErrorMsg: this.language.error500header})
          })
      } else {
        this.resetMsgAndErrors()
        this.deactivateValidatingForm()
      }
    },
    deleteToAPI (code, id) {
      // delete repeatable element from no persisted group repeatable element
      if (!this.type.actions.delete && code !== undefined) {
        this.formAddRemoved = {
          code: code,
          id: id,
          removed: true,
          ts: moment().valueOf()
        }
      // delete repeatable element from persisted group repeatable element
      // or all generic element
      } else if (this.definitionContentId) {
        var apiCode = this.definitionContentCode
        if (code !== undefined) {
          apiCode = code
        }

        api.call({domainEndpoint: this.type.domainEndpoint, url: this.type.actions.delete.endpoint, token: this.type.token, version: this.type.version, method: 'POST', lang: this.getLang(), authorization: this.authorization, data: { id: this.definitionContentId, code: apiCode, requestObject: this.definitionContent.requestObject }})
          .then(resp => {
            this.formConfirmDelete = false
            if (resp.requestResult) {
              this.formDeleted = true
              if (code) {
                this.formAddRemoved = {
                  code: code,
                  id: id,
                  removed: true,
                  ts: moment().valueOf()
                }
                this.$emit('formDataActionCalled', true)
              } else {
                this.$emit('formDataActionCalled', false)

                if (this.fromPopup) {
                  this.$emit('popupClose')
                } else {
                  this.$emit('closeDetail')
                  this.$emit('definitiondeleted', this.definitionContent.requestObject, resp)
                }
              }

              if (this.type.actions.delete.callback && this.type.actions.delete.callback.success) {
                if (this.type.actions.delete.callback.success !== this.id) {
                  this.$emit('changeUrl', {name: this.type.actions.delete.callback.success, params: { id: this.definitionContentId }})
                } else {
                  this.getDefinitionContent(true)
                }
              }
            } else {
              this.apiError(resp, {response: {status: 500}}, resp.requestResultError)
              if (this.type.actions.delete.callback && this.type.actions.delete.callback.error) {
                if (this.type.actions.delete.callback.error !== this.id) {
                  this.$emit('changeUrl', {name: this.type.actions.delete.callback.error, params: { id: this.definitionContentId }})
                } else {
                  this.getDefinitionContent(true)
                }
              } else {
                if (code) {
                  this.formAddRemoved = {
                    code: code,
                    id: id,
                    removed: false,
                    ts: moment().valueOf()
                  }
                }
              }
              this.$emit('definitiondeleted', this.definitionContent.requestObject, resp)
            }
          })
          .catch(err => {
            this.resetMsgAndErrors()
            this.deactivateValidatingForm()
            this.apiError(null, err, {requestErrorType: 'SYSTEM', requestErrorMsg: this.language.error500header})
          })
      } else {
        this.resetMsgAndErrors()
        this.deactivateValidatingForm()
        this.formConfirmDelete = false
      }
    },
    getRepeatableGroupId (reqDef) {
      var repeatableGroupId = null
      if (transport.methods.isRepeatableGroup(reqDef)) {
        repeatableGroupId = reqDef.id
      }
      return repeatableGroupId
    },
    isRepeatableGroup (reqDef) {
      return transport.methods.isRepeatableGroup(reqDef)
    },
    errorAddForm (formAddErrors) {
      this.formAddErrors = formAddErrors
    },
    errorModifyForm (formModifyErrors) {
      this.formModifyErrors = formModifyErrors
      if (this.formModifyErrors === 0) {
        this.deactivateValidatingForm()
      }
    },
    addSaved (code) {
      this.formAddSaved = true
      if (this.type.actions.update) {
        this.checkForm(true, 'update', 'refresh', code)
      } else {
        this.refreshDefinition(null)
        var self = this
        setTimeout(function () {
          self.formAddSaved = false
        }, 3000)
      }
    },
    modifyDefinitionContentRequestObject (object, callUpdate, code) {
      if (object) {
        for (var i = 0; i < this.definitionContent.requestObject.length; i++) {
          this.definitionContent.requestObject[i] = transport.methods.modifyRequestObject(this.definitionContent.requestObject[i], object)
        }

        if (callUpdate && this.type.actions.update) {
          this.checkForm(true, 'update', 'refresh', code)
        }
      }
      this.deactivateValidatingAddForm()
      this.$emit('refreshDefinition', object)
    },
    modifyingAddForm (code) {
      this.activateValidatingAddForm(null, code)
    },
    removingAddForm (code, id) {
      this.deleteToAPI(code, id)
    },
    newLanguageSelected (language) {
      if (this.languageSelected) {
        this.previousLanguageKey = this.languageSelected.key
      }
      this.languageSelected = language
      var languageSelectedKey = null
      if (this.languageSelected) {
        languageSelectedKey = this.languageSelected.key
      }
      this.fieldsHeader = this.visualDefinition.getDefinitionFieldsHeader(this.id, this.definitionContent.requestDefinition, this.definitionContent.requestObject, languageSelectedKey)

      // Editor: call save for get language html and content
      if (this.isTemplate()) {
        this.saveTemplate = {
          ts: moment().valueOf(),
          mode: 'language',
          stayAfter: null,
          goToAfterSave: null
        }
      }
    },
    conditionalDefinitionChange (conditionalFieldId, newReqObj) {
      transport.methods.changeConditionalObjects(this.definitionContent.requestObject, conditionalFieldId, newReqObj)
    },
    popupClose () {
      this.resultSuccessMsg = null
    },
    definitionLoaded () {
      this.$emit('definitionloaded', this.definitionContent, this.onloadfunction, this.loadedstyleclasses, this.sdcontainer)
    },
    editorSave (template, html) {
      var contentObj = this.getRequestObjectById('apptmpl_template_contentmetadata')
      var contentHtmlObj = this.getRequestObjectById('apptmpl_template_contenthtml')

      // not equals languages = language change
      if (this.previousLanguageKey !== this.languageSelected.key) {
        this.savingLanguageTemplate = true
      }

      // save template before language change
      if (this.savingLanguageTemplate) {
        transport.methods.setLanguageValue(contentObj, template, this.previousLanguageKey)
        transport.methods.setLanguageValue(contentHtmlObj, html, this.previousLanguageKey)

        var self = this
        setTimeout(function () {
          self.savingLanguageTemplate = false
          if (this.languageSelected) {
            this.previousLanguageKey = this.languageSelected.key
          }
        }, 500)

      // save template before copy template to other languages
      } else if (this.copyingTemplateLanguage) {
        transport.methods.setLanguageValue(contentObj, template, this.languageSelected.key)
        transport.methods.setLanguageValue(contentHtmlObj, html, this.languageSelected.key)

        this.copyTemplate()

      // call save template service
      } else {
        transport.methods.setLanguageValue(contentObj, template, this.languageSelected.key)
        transport.methods.setLanguageValue(contentHtmlObj, html, this.languageSelected.key)

        if (this.saveTemplate.mode === 'create') {
          this.checkForm(this.saveTemplate.stayAfter, 'create', this.saveTemplate.goToAfterSave)
        } else if (this.saveTemplate.mode === 'update') {
          this.checkForm(this.saveTemplate.stayAfter, 'update', this.saveTemplate.goToAfterSave)
        }
      }
    },
    getTemplateValue (name) {
      var result
      var namePreffix = 'apptmpl_template_'

      var definition = transport.methods.getRequestDefinitionById(namePreffix + name, this.definitionContent.requestDefinition)

      result = transport.methods.getObjectTextValue(
        this.visualDefinition.definition,
        definition,
        this.getRequestObjectById(namePreffix + name),
        null
      )
      if (result === '-') {
        if (name === 'templateurl' || name === 'contentmetadata') {
          result = null
        } else if (name === 'title' || name === 'id') {
          result = ''
        }
      } else {
        if (name === 'created') {
          var date = transport.methods.getDate(result, definition)
          result = date.getTime()
        } else if (name === 'contentmetadata') {
          result = JSON.parse(result)
        }
      }

      return result
    },
    getTemplateDomain (name) {
      var namePreffix = 'apptmpl_template_'
      var definition = transport.methods.getRequestDefinitionById(namePreffix + name, this.definitionContent.requestDefinition)
      return definition.validation.domain
    },
    getContentValue () {
      var result
      var name = 'apptmpl_template_contentmetadata'
      result = transport.methods.getLanguageValue(this.getRequestObjectById(name), this.languageSelected.key)
      if (result === '') {
        result = null
      } else {
        result = JSON.parse(result)
      }
      return result
    },
    getTypeValue () {
      var result = ''
      if (this.id.indexOf('email') > -1) {
        result = 'newsletter'
      } else if (this.id.indexOf('landing') > -1) {
        result = 'webpage'
      } else {
        result = 'webpage'
      }
      return result
    },
    getTemplateReqDef (name) {
      var namePreffix = 'apptmpl_template_'
      return transport.methods.getRequestDefinitionById(namePreffix + name, this.definitionContent.requestDefinition)
    },
    getTemplateReqObj (name) {
      var namePreffix = 'apptmpl_template_'
      return transport.methods.getRequestObjectById(namePreffix + name, this.definitionContent.requestObject)
    },
    launchCopyTemplate (fromLanguage) {
      this.copyingTemplateLanguage = fromLanguage
      // Editor: call save for get language html and content
      this.saveTemplate = {
        ts: moment().valueOf(),
        mode: 'copy',
        stayAfter: null,
        goToAfterSave: null
      }
    },
    copyTemplate () {
      this.translating = true
      var self = this
      setTimeout(function () {
        self.copyTemplateLanguage(self.copyingTemplateLanguage, 0, self.getTemplateReqObj('contentmetadata'))
        self.copyTemplateLanguage(self.copyingTemplateLanguage, 0, self.getTemplateReqObj('contenthtml'))
        self.copyingTemplateLanguage = null
      }, 500)
    },
    copyTemplateLanguage (fromLanguage, index, object) {
      if (index < object.languageValue.length) {
        var language = object.languageValue[index]
        if (language.key !== fromLanguage.key && language.value.trim() === '') {
          object = transport.methods.setLanguageValue(object, transport.methods.getLanguageValue(object, this.languageSelected.key), language.key)
        }
        this.copyTemplateLanguage(fromLanguage, ++index, object)
      } else {
        var self = this
        setTimeout(function () {
          self.translating = false
        }, 200)
      }
    },
    getDefinitionFieldClassTaskClass (reqDef) {
      var definition = this.visualDefinition.getDefinitionFields(reqDef.id)
      return definition.tasks
    },
    diagramSaved (xml, svg) {
      console.log(xml, svg)
    },
    getLang (key) {
      return language(this.language, key)
    },
    callSaveOrUpdate (stay) {
      // modify
      if (this.definitionContentId && this.type.actions.update) {
        this.callUpdate(stay, this.saveDefinitionTo)
      // create
      } else if (this.type.actions.create) {
        this.callCreate(stay, this.saveDefinitionTo)
      }
    },
    definitionCarouselAction (carouselAction) {
      if (carouselAction && (carouselAction.action === 'navigation' ||
        carouselAction.action === 'pagination') && carouselAction.actionData &&
        carouselAction.actionData.validation === false) {
        this.formErrors = 1
      } else {
        this.formErrors = 0
      }
      this.$emit('definitioncarouselaction', carouselAction)
    },
    refreshDefinitionContent () {
      this.getDefinitionContent(true)
    },
    setEmbeddedIdCode () {
      if (this.embeddedDefinition.id) {
        this.definitionContentId = this.embeddedDefinition.id
      }
      if (this.embeddedDefinition.code) {
        this.definitionContentCode = this.embeddedDefinition.code
      }
    },
    waitingProcessInit () {
      this.$emit('waitingProcessInit')
    }
  },
  watch: {
    content (content) {
      this.resetMsgAndErrors()
      this.deactivateValidatingForm()
      this.getDefinitionContent()
    },
    saveDefinition (saveDefinition) {
      if (saveDefinition) {
        this.callSaveOrUpdate()
      }
    },
    builderModifyCall (builderModifyCall) {
      if (builderModifyCall) {
        this.setEmbeddedIdCode()
        this.callSaveOrUpdate(true)
      }
    },
    builderDeleteCall (builderDeleteCall) {
      if (builderDeleteCall) {
        this.setEmbeddedIdCode()
        this.callDelete(false)
      }
    },
    validateForm (validateForm) {
      // Carousel validation refresh
      if (this.isCarousel()) {
        var newCarouselValidateForm = []
        for (var i = 0; i < this.definitionContent.requestDefinition.length; i++) {
          newCarouselValidateForm.push({
            validating: true,
            timeEvent: moment().valueOf()
          })
        }
        this.carouselValidateForm = newCarouselValidateForm
      }
    }
  }
}
</script>

<style lang="scss">
.loadingDefinition {
  position: absolute;
  top: 42px;
  left: 0;
  right: 0;
}
#container_form_definition.open {
    overflow-y: auto;
    background-color: white !important;
}
#container_form_definition>div.searcher-padding {
    padding: 30px 0 10px;
}
#container_form_definition.open #icon_filter {
    color: #ff7643;
}
#form_definition {
  position: relative;
  overflow-y: initial !important;
  transition: max-height .6s ease-in;
}
#container_form_definition.open #form_definition {
  max-height: 0;
  transition: max-height .6s ease-out;
}
.definition-title {

  &.dotted {
    border-bottom: 1px dotted #4599a4;
  }

  .fieldsHeaderTitle {
    margin-bottom: 20px;
  }

  span:first-of-type{
    font-family: Capriola;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #4599a4;
    padding-bottom: 7px;
    display: none;
    margin-bottom: 8px;

    i {
      margin-left: 15px;
      cursor: pointer;
    }
  }
}
#icon_filter {
  transition: transform .6s;
  z-index: 9999;
}
#container_form_definition.open #icon_filter {
  -ms-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}
#container_form_definition.definition {
  background: none !important;
}

.noPadding > .group {
  padding: 0 !important;
}
.noMargin > .group {
  margin: 0 !important;
}

.app-container {
  #container_form_definition {
    position: relative;
    width: 100%;

    &.new {
      padding-bottom: 110px;
    }

    .definition-wrapper.group {
      width: 100%;
      min-height: 130px;
      margin: 0 0 10px;
      padding: 15px 10px 5px;
      float: left;
      background-color: #f8f8f8;

      div.title {
        font-size: 16px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: 1;
        letter-spacing: normal;
        color: #342d38;
        display: inline-block;

        .labelText {
          margin-top: 0;
          margin-bottom: 0;
          display: inline-block;
          font-family: Capriola;
          color: #4599a4;
          vertical-align: baseline;

          i {
            margin-right: 5px;
            font-size: 20px;
            vertical-align: middle;

            &:before {
              font-weight: 100;
            }
          }
        }
      }

      .definition-wrapper.group {
        div.title {
          font-size: 14px;
          font-weight: 100;
        }
      }

      ul {
        list-style: none;

        li span {
          font-size: 12px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.25;
          letter-spacing: normal;
          color: #342d38;
        }

        span:first-child {
          font-weight: bold;
        }
        span:first-child.required {
          font-weight: bold;
        }
      }
    }
    .definition-wrapper .group.error_group_validate {
      border: 1px solid #cf0000;
    }
  }
}

.template-html {
  padding: 0 50px 0 0 !important;
}
.template {
  .template-html {
    display: none;
  }
  .languageSelectorOrTask {
    position: absolute;
    left: 125px;
    top: 13px;
    z-index: 1;
  }
}
#detail {
  .template {
    .languageSelectorOrTask {
      top: -15px;
    }
  }
}
.mosaico-editor-container {
  #main-toolbox {
    #tooltabs.ui-tabs {
      text-align: center;

      .ui-tabs-nav {
        position: relative !important;
        display: inline-block;
        margin: 0 auto;
      }

      #toolblocks {
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
      }
    }
  }
  #toolbar {
    text-align: center;

    .leftButtons {
      float: none !important;
    }
    .rightButtons {
      display: none !important;
    }
  }
  #main-wysiwyg-area{
    replacedbody {
      max-width: none !important;
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
    }
  }

  #frame-container {
    box-shadow: none !important;
    background-color: transparent !important;

    > iframe {
      padding: 0 !important;
      border-radius: 6px !important;
    }
  }
}

.new-email-template,
.get-email-template,
.new-landing-template,
.get-landing-template {
  #page {
    right: 50px !important;
  }
  #quest_bloc_agrupacio-0-1 {
    > .group {
      background-color: transparent !important;
      padding: 0 !important;
      min-height: 100px !important;

      #apptmpl_template_title {
        padding: 0 15px 0 0;
        min-height: 100px !important;

        label {
          font-size: 1.1em;
        }

        input {
          background-color: #efefef;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.item {
  min-height: 90px;
}
</style>

<style lang="scss">
.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: #5dbecb;
    color: white;
    border-radius: 9px;
    padding: 5px 15px 5px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: #5dbecb;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 6px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &.popover {
    $color: #f9f9f9;

    .popover-inner {
      background: $color;
      color: black;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, .1);
    }

    .popover-arrow {
      border-color: $color;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}

.carousel {
  .VueCarousel-navigation-button {
    font-size: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/vue-definition/src/components/definition.vue